// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});
/* eslint-enable no-console */


document.addEventListener('click', function (event) {
  if (event.target.matches('.expander') || event.target.closest('.expander')) {
    let expander = event.target.closest('.expander');
    expander.classList.toggle("expander");
    let span = expander.querySelector("span");
    if (span) {
      span.classList.toggle("hide-expand-toggle");
    }
  }
});



window.onload = function() {
  // Check if the tooltip has been shown before using localStorage
  var isTooltipShown = localStorage.getItem('tooltipSeen');

  if (!isTooltipShown) {
    // If the tooltip hasn't been shown, show it and add pulse effect
    var featureElement = document.getElementById('highlight-list-toggle');
    featureElement.classList.add('highlight-pulse', 'show-tooltip');

    // "Got it" button functionality
    var gotItBtn = document.getElementById('got-it-btn');
    gotItBtn.addEventListener('click', function() {
      // Remove the tooltip and pulse effect
      featureElement.classList.remove('highlight-pulse', 'show-tooltip');

      // Set a flag in localStorage to mark that the user has seen the tooltip
      localStorage.setItem('tooltipSeen', 'true');
    });

    // Optionally, you can still auto-remove it after a certain time (e.g., 15 seconds)
    setTimeout(function() {
      featureElement.classList.remove('highlight-pulse', 'show-tooltip');

      // Set the flag in localStorage even if the user doesn't click "Got it"
      localStorage.setItem('tooltipSeen', 'true');
    }, 15000); // Tooltip and pulse stay for 15 seconds if not dismissed
  }
};


// $('.search__results').on('click', '.expander', function () {
//   $(this).toggleClass("expander");
//   $(this).children("span").toggleClass("hide-expand-toggle");
// });

$(document).on('click', '.expander', function () {
  $(this).toggleClass("expander");
  $(this).children("span").toggleClass("hide-expand-toggle");
});


